<template>
  <div>
    <v-app-bar
      flat
      app
    >
      <v-row align="center">
        <v-app-bar-nav-icon
          class="nav-icon"
          @click.stop=";(drawer = !drawer), $emit('open-drawer', drawer)"
        />
        <a
          href="/"
          class="subtitle-2"
        >
          <v-img
            src="@/assets/images/logo-britecheck-grey.svg"
            style="width: 220px; height: 36px;"
          />
        </a>
        <v-spacer />
        <div class="warehouse-select-button px-5">
          <selectWarehouse />
        </div>
        <UserTopMenu />
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
import selectWarehouse from '@/components/warehouses/sidebar/selectWarehouse'
import UserTopMenu from '@/components/top-bar/UserTopMenu'
export default {
  name: 'Topbar',
  components: {
    selectWarehouse,
    UserTopMenu
  },
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    onSearch() {}
  }
}
</script>

<style scoped>
.v-app-bar {
  border-bottom: 1px solid #e7e7e7;
  left: 0 !important;
  width: 100%;
  border-bottom-width: 2px;
}

.subtitle-2 {
  margin: 0 10px;
}
::v-deep .v-toolbar__content {
  padding: 4px 10px;
}
</style>
